export default {"src":"/_next/static/media/caret-right-dark.7be419b4.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};